import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '../mock/mockData';

export default function Services() {
  return (
    <div className="pt-24">
      <section className="bg-forest-950 py-24">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="text-sage-400 tracking-[0.3em] text-xs uppercase mb-5 reveal">What we do</p>
          <h1 className="font-serif text-cream-50 text-5xl md:text-7xl leading-tight reveal">Our Services</h1>
          <p className="mt-6 text-cream-100/75 text-lg max-w-2xl reveal">Practical, commercial legal advice delivered by an experienced team across property, business, disputes and social housing.</p>
        </div>
      </section>

      <section className="bg-forest-900 py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <Link key={s.slug} to={`/services/${s.slug}`} className="group relative overflow-hidden bg-forest-950 border border-forest-800 hover:border-sage-500/50 transition-colors reveal" style={{transitionDelay: `${i * 70}ms`}}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={s.image} alt={s.name} className="w-full h-full object-cover opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
              </div>
              <div className="p-6">
                <h3 className="font-serif text-cream-50 text-2xl group-hover:text-sage-400 transition-colors">{s.name}</h3>
                <p className="mt-3 text-cream-100/70 text-sm leading-relaxed">{s.tagline}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sage-400 text-xs tracking-widest uppercase">Learn more <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
